import * as vaccination from './vaccination.js';

export default {
    vaccination,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Vaccination
    window.EQLAPP.VACCINATION = window.EQLAPP.VACCINATION || {};
    Object.entries(vaccination).forEach(([key, value]) => {
        window.EQLAPP.VACCINATION[key] = value;
    });

}